import { C } from "../core/config.js";
import { btnStyle } from "../core/utils.js";

// ─── Cargar una imagen sin pasar por el explorador de archivos ───────────────
// La foto del producto casi siempre está en la pantalla: en el catálogo del
// proveedor, en un correo, en un WhatsApp. Antes había que bajarla al disco,
// acordarse de dónde quedó y volver a buscarla en el explorador. Aquí se pega
// con Ctrl+V —o se arrastra— y listo; el archivo sigue siendo una opción.
//
// `destino` dice a qué borrador va la imagen: "crearProducto" (creación rápida
// desde un ítem de la cotización) o "maestro" (ficha del producto en Maestros).
export function zonaImagenHTML({ destino, inputId, imagen, obligatoria }) {
  const falta = obligatoria && !imagen;
  return `
    <div data-img-zona="${destino}" data-img-input="${inputId}"
      style="display:flex;gap:11px;align-items:center;border:1.5px dashed ${falta ? C.red + "80" : C.border};
             border-radius:8px;padding:10px 12px;background:#f8fafc;transition:background .15s,border-color .15s;">
      ${imagen
        ? `<img data-img-preview="${destino}" src="${imagen}" alt="Imagen del producto"
             style="height:70px;width:70px;object-fit:contain;border-radius:6px;border:1px solid ${C.border};background:white;flex-shrink:0;"/>`
        : `<div style="height:70px;width:70px;border:1px dashed ${falta ? C.red + "80" : C.border};border-radius:6px;
                     display:flex;align-items:center;justify-content:center;color:${falta ? C.red : C.muted};font-size:20px;flex-shrink:0;background:white;">🖼️</div>`}
      <div style="flex:1;min-width:0;">
        <div style="font-size:11.5px;color:${C.text};font-weight:600;">
          📋 Pega aquí tu captura con <span style="font-family:ui-monospace,monospace;background:${C.border}66;border-radius:4px;padding:1px 5px;">Ctrl+V</span>
        </div>
        <div style="font-size:10.5px;color:${C.muted};margin-top:2px;">
          También puedes arrastrar la imagen encima o elegir el archivo.
        </div>
        <div style="display:flex;gap:7px;align-items:center;margin-top:7px;flex-wrap:wrap;">
          <button type="button" data-action="pegar-imagen" data-destino="${destino}"
            title="Toma la imagen que tengas copiada en el portapapeles"
            style="${btnStyle(C.blue, null, true)}font-size:10.5px;">📋 Pegar del portapapeles</button>
          <input type="file" id="${inputId}" accept="image/*" style="font-size:10.5px;max-width:200px;"/>
        </div>
      </div>
    </div>`;
}
